<template lang="pug">
.navbar-search.navbar-search-mobile(:class="searchActive ? 'navbar-search--active' : ''" @click="inputFoucs()")
  input.navbar-input.navbar-input-mobile.text--18.color--greyCharcoal30(v-if="searchActive" ref="searchInput" v-model="searchKeyword" placeholder="搜尋話題" @keyup.enter="search()" autocomplete="off")
  i.navbar-iconSearch(@click="searchActive = !searchActive")
  i.navbar-searchCloseIcon.icon-sidemenu-close(@click="searchActive = !searchActive")
  .navbar-searchListWrapper(v-if="searchActive")
    .navbar-searchList
      .navbar-searchItem(v-for="text in navbarSearchText" @click="clickOption(text)")
        i.icon-searched
        span.navbar-searchText {{ text }}
</template>

<script>
import $ from 'jquery';
export default {
  props: {
    userProfile: Object,
    navbarSearchText: Array
  },
  data() {
    return {
      searchKeyword: this.$route.query.keyword ? this.$route.query.keyword : '',
      searchActive: false
    };
  },
  methods: {
    search() {
      let trimKeyWord = $.trim(this.searchKeyword);
      if (trimKeyWord.length == 0) return;
      this.$router.push({
        path: '/category',
        query: {
          type: 'searchArticles',
          keyword: trimKeyWord
        }
      });
      this.searchActive = false;
    },
    clickOption(text) {
      this.searchKeyword = text;
      this.search();
    },
    inputFoucs() {
      if (this.$refs.searchInput) this.$refs.searchInput.focus();
    }
  }
};
</script>
<style scoped src="./navbar_search_mobile.vue.css"></style>
